<template>
  <v-container grid-list-sm id="resume">
    <!-- {{ $store.state.selJob }} -->
    <form @submit.prevent="submitData">
      <resume1 class="mt-2" label="ตำแหน่งงาน (POSTION)"></resume1>
      <resume2 class="mt-2" label="ประวัติส่วนตัว (PERSONAL DATA)"></resume2>
      <resume3 class="mt-2" label="รายละเอียดครอบครัว (FAMILY DATA)"></resume3>
      <resume4
        class="mt-2"
        label="ประวัติการศึกษา (EDUCATION BACKGROUND)"
      ></resume4>
      <Resume5
        class="mt-2"
        label="ประวัติการทำงาน (ทั้งทำงานชั่วคราว/การฝึกงาน)(INCLUDING TEMPORARY WORK / PRACTICAL TRAINING)"
      ></Resume5>
      <Resume6
        class="mt-2"
        label="ความสามารถพิเศษ (SPECIAL ABILITIES)"
      ></Resume6>
      <Resume7
        class="mt-2"
        label="บุคคลที่สามารถรับรองความประพฤติของท่าน (REFERENCES)"
      ></Resume7>
      <Resume8
        class="mt-2"
        label="กรณีฉุกเฉินติดต่อ (IN EMERGENCY CASE PLEASE CONTACT)"
      ></Resume8>
      <Resume9 class="mt-2" label="การฝึกอบรม (TRAINING COURSE)"></Resume9>
      <Resume10 class="mt-2" label="ส่วนเพิ่มเติมอื่น ๆ"></Resume10>
      <Resume11 class="mt-2" label="เอกสารแนป"></Resume11>
      <v-row>
        <v-col cols="12" class="justify-end d-flex mt-2">
          <v-btn color="success" x-large class="mr-2" type="submit"
            ><v-icon left>mdi-content-save</v-icon> ส่งข้อมูลสมัครงาน</v-btn
          >
          <v-btn color="warning" x-large>กรอกใหม่</v-btn>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>
import Resume11 from "../components/resume11";
import Resume10 from "../components/resume10";
import Resume9 from "../components/resume9";
import Resume8 from "../components/resume8";
import Resume7 from "../components/resume7";
import Resume6 from "../components/resume6";
import Resume5 from "../components/resume5";
import resume1 from "../components/resume1";
import resume2 from "../components/resume2";
import resume3 from "../components/resume3";
import resume4 from "../components/resume4";
import Swal from 'sweetalert2';
export default {
  name: "resume",
  components: {
    Resume11,
    Resume10,
    Resume9,
    Resume8,
    Resume7,
    Resume6,
    Resume5,
    resume1,
    resume2,
    resume3,
    resume4,
  },
  data() {
    return {};
  },
  methods: {
    initialize() {
      if(this.$store.state.statFromLogin!=true)
      {
        this.$router.push({path:'/'});
      }
    },
    submitData() {
      if(this.$store.getters.get_selJob.length>0){
      let formData = new FormData();
      formData.append("file_photo",this.$store.state.dataFrm.tea_regis_photo);

      formData.append("data", JSON.stringify(this.$store.state.dataFrm));
      formData.append("list_job_id",JSON.stringify(this.$store.getters.get_selJob));
      formData.append("regis_teac_edu",JSON.stringify(this.$store.getters.get_Educate_Level));
      formData.append("list_hiswork",JSON.stringify(this.$store.state.dataFrm.list_hiswork));
      formData.append("list_Special",JSON.stringify(this.$store.state.dataFrm.list_Special));
      formData.append("list_Ref",JSON.stringify(this.$store.state.dataFrm.list_Ref));
      formData.append("list_Emer",JSON.stringify(this.$store.state.dataFrm.list_Emer));
      formData.append("list_train",JSON.stringify(this.$store.state.dataFrm.list_train));
      formData.append("file_people_card",this.$store.state.dataFrm.file_people_card);
      formData.append("file_transcrip_tree",this.$store.state.dataFrm.file_transcrip_tree);
      formData.append("file_transcrip_pvs",this.$store.state.dataFrm.file_transcrip_pvs);
      formData.append("file_other",this.$store.state.dataFrm.file_other);
      this.$store.state.statFromLogin = false;
      this.$store.dispatch("updateData", formData);
      }
      else {
        Swal.fire("Alert","กรุณาเลือกตำแหน่งงานที่ต้องการสมัคร","warning");
      }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style></style>
